import {Routes} from '@angular/router';

import {
        redirectLoggedInToHome,
        redirectToLanding,
        redirectVerifiedToHome
} from './guard-helpers';

export const authRoutes: Routes = [
        {
                path: 'verify-email',
                canActivate: [redirectVerifiedToHome],
                loadComponent: () => import('../pages/verify-email/verify-email-page.component').then((c) => c.VerifyEmailPageComponent)
        },
        {
                path: 'login',
                canActivate: [redirectLoggedInToHome],
                loadComponent: () => import('../pages/login/login').then((c) => c.LoginPageComponent)
        },
        {
                path: 'password-reset',
                canActivate: [redirectToLanding],
                loadComponent: () => import('../pages/login/password-reset/password-reset-page.component').then((c) => c.PasswordResetPageComponent)
        },
        {
                path: 'register',
                canActivate: [redirectLoggedInToHome],
                loadComponent: () => import('../pages/register/register.component').then((c) => c.RegisterComponent)
        }
];
